// extracted by mini-css-extract-plugin
export var content = "SectionTitle-module--content--adfd7";
export var headline = "SectionTitle-module--headline--b197a";